export default __webpack_public_path__ + "static/media/silencer-protector.85d142f3.jpg";